import { Product } from '../../products/shared/product';
export class Category {
  $key: string;
  name: string;
  products: Product[];
  
  constructor(values: Object = {}) {

    Object.assign(this, values);

  };

}



// WEBPACK FOOTER //
// ./src/app/category/shared/category.ts